import { store } from '../../store';
import { subscribeInventoriesAction } from '../../ReduxSlices/Inventories/inventorySlice';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribeInventory = null; // store unsubscribe function

export const initializeInventorySubscription = () => {
  if (unsubscribeInventory) return; // already subscribed

  // Provide a unique module key "inventory"
  unsubscribeInventory = subscribeToCoreUpdates("inventory", {
    "inventory.created": (data) => {
      store.dispatch(subscribeInventoriesAction({ action: "created", inventory: data  }));
    },
    "inventory.updated": (data) => {
      store.dispatch(subscribeInventoriesAction({ action: "updated", inventory: data }));
    },
    "inventory.deleted": (data) => {
      store.dispatch(subscribeInventoriesAction({ action: "deleted", inventory: data }));
    }
  });

 // console.log("✅ Inventory subscription initialized");
};

export const unsubscribeInventorySubscription = () => {
  if (unsubscribeInventory) {
    unsubscribeInventory(); // remove only Inventory handlers
    unsubscribeInventory = null;
   // console.log("🔌 Inventory subscription removed");
  }
};